import { Rum } from "./rum";

const L9RUM = new Rum();

(window as any).L9RUM = L9RUM;
(globalThis as any).L9RUM = L9RUM;
export default L9RUM;

declare global {
  interface Window {
    L9RUM: Rum;
  }
  var L9RUM: Rum;
}
